import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/fontawesome-free-solid'
import Spinner from './Spinner';

const Loading = () => {
    return (
        <div className="loading">
            <Spinner/>
        </div>
    );
};

export default Loading;